<!--
@Author: Calvin Green <calvin>
@Date:   2022-03-01T17:27:49+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-05-13T10:17:56+02:00
@Copyright: Diversitude 2022
-->



<template>
    <div>
            <b-row v-if="current_sop != null">
                <b-col cols="12">
                    <b-card>

                            <i @click="close" style="font-size: 4rem;" class="fas fa-times text-dark me-3"></i>
                            <span style="font-size: 2.6rem;">Distribute {{current_sop.name}}</span>

                    </b-card>
                </b-col>
                <b-col cols="6" v-if="is_error == false">
                    <b-card>
                        <div v-if="b64 == null">
                            <b-alert show>Loading PDF</b-alert>
                        </div>
                        <div v-else>
                            <iframe :src="b64" style="width: 100%; height: 70vh;"></iframe>


                        </div>
                    </b-card>
                </b-col>
                <b-col cols="6" v-if="is_error == false">
                    <b-card>
                        <b-row v-if="distribution_clients != null">
                            <b-col cols="12">
                                <h6>Search Company</h6>
                                <input
                                    style="height: 2.2rem; width: 2.1rem; min-height: 1.5rem; min-width: 1.5rem;"
                                    class="form-check-input me-2 mt-0"
                                    v-model="all_clients"
                                    type="checkbox"/>
                                <vue-typeahead-bootstrap
                                :disabled="all_clients"
                                style="display: inline-block;"
                                ref="clientTypeahead"
                                :showOnFocus="true"
                                @hit="findClient($event)"
                                v-model="query"
                                :data="clientsList"
                                :minMatchingChars="1"
                                />
                                <hr>
                            </b-col>

                            <b-col cols="12">
                                <h6>Added Companies</h6>
                                <simplebar v-if="all_clients == false" style="max-height: 400px" id="containerElement" ref="current">

                                    <ol v-for="(client) in added_clients" :key="client.id" style="border: 1px solid black;">
                                        <li>
                                            <span>{{client.company_name}}</span>
                                            <span class="ms-4">
                                                <i @click="removeClientFromList(client.id)" style="cursor:pointer;" class="fas fa-trash"></i>
                                            </span>
                                        </li>
                                    </ol>
                                </simplebar>
                                <div v-else>
                                    <b-alert variant="primary" show>
                                        <strong>All Clients Selected</strong>
                                    </b-alert>
                                </div>
                                <b-button @click="distributeDocument" v-if="showButton" variant="outline-primary" style="float: right; font-weight: bold;" class="ms-auto">
                                    <span v-if="all_clients">Send To All</span>
                                    <span v-else>
                                        Send To Selected
                                    </span>
                                </b-button>



                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>

                <b-col cols="12" v-if="is_error">
                    <b-alert show variant="danger">
                        <h4>
                            This SOP has not been published yet.
                        </h4>
                    </b-alert>
                </b-col>

            </b-row>
    </div>
</template>

<script>
//eslint-disable-next-line
import Swal from 'sweetalert2';
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'
import _ from 'lodash';
import { sopAdminState, sopAdminMethods} from '@/state/helpers';
import simplebar from 'simplebar-vue'
export default {
    components:{
        VueTypeaheadBootstrap,
        simplebar,
    },
    data:() => ({
        is_error: false,
        revision_id: null,
        current_sop: null,
        added_clients:[],
        all_clients: false,
        query:'',

        b64: null,
        base: null,

        lastRevision: null,
    }),
    computed:{
        ...sopAdminState,
        showButton(){
            if(this.all_clients){
                return true;
            }
            else{
                if(this.added_clients.length > 0 ){
                    return true;
                }
                else{
                    return false;
                }
            }
        },
        selectedDocumentID(){
            let id = this.context_menu_id;
            return id;
        },
        clientsList(){
            let data = [];
            if(this.distribution_clients != null){
                this.distribution_clients.forEach( client => {
                    let index = _.findIndex(this.added_clients, {id: client.id});
                    if(index == -1){
                        data.push(client.company_name);
                    }
                })
            }
            return data;
        }
    },
    methods:{
        ...sopAdminMethods,
        close(){
            this.$emit('back');
        },
        removeClientFromList(id){
            let index = _.findIndex(this.added_clients, {id: id})
            if(index != -1){
                this.added_clients.splice(index, 1);
            }
        },
        distributeDocument(){
            let params = {
                revision_id: this.revision_id,
            }
            if(this.all_clients){
                params['all_clients'] = true;
                params['clients'] = [];
            }
            else{
                params['clients'] = [];
                this.added_clients.forEach( client => {
                    params.clients.push({id: client.id})
                })
            }

            this.distributeSop(params)
            .then(()=>{
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'white',
                    icon: 'success',
                    title:'Document distributed.',
                    customClass: {     popup: 'success-toast2' },
                    showConfirmButton: false,
                    timer: 4000,
                    //timer: 2000, timerProgressBar: true
                });
            })
            .catch(()=>{
                console.log('Distribution error')
            })
        },
        findSOP(){
            if(this.sops != null){
                let index = _.findIndex(this.sops.sop_types, {id: this.selectedDocumentID});
                if(index != -1){
                    this.current_sop = this.sops.sop_types[index];
                    this.loadSopForDistribution(this.current_sop.id)
                    .then(()=>{
                        if(this.distribution_sop.revisions.length > 0){
                            let published_index = _.findIndex(this.distribution_sop.revisions, {published: 1});
                            if(published_index != -1){
                                //let last_index = this.distribution_sop.revisions.length - 1
                                let last_revision = this.distribution_sop.revisions[published_index];

                                this.revision_id = last_revision.revision_id;
                                this.lastRevision = last_revision;

                                if(this.lastRevision.published == 1){
                                    //* Use cached pdf
                                    this.getCachedSopPreview(this.revision_id).then( response =>{
                                        this.b64 = response.temp_url;
                                    })
                                }
                                else{
                                    Swal.fire({
                                        toast: true,
                                        position: 'top',
                                        iconColor: 'blue',
                                        icon: 'info',
                                        title:'Waiting for PDF to generate',
                                        customClass: {     popup: 'success-toast' },
                                        showConfirmButton: false,
                                        timer: 3000,
                                        //timer: 2000, timerProgressBar: true
                                    });
                                    let params = { revision_id: this.lastRevision.revision_id}
                                    this.previewSop(params)
                                    .then( response => {
                                        this.b64 = response.b64;
                                    });
                                }
                            }
                            else{
                                this.is_error = true;
                            }



                        }
                    })
                }
            }
        },
        //* typeahead match method
        findClient(string){
            if(this.clientsList != null){
                let obj = _.find(this.distribution_clients, { company_name : string });
                if(obj != undefined){
                    this.added_clients.push(obj);
                    this.query = '';
                    this.$refs.clientTypeahead.inputValue = '';
                }
                else{
                    console.log('Typeahead find client error')
                }
            }
        },
    },
    mounted(){
        this.findSOP();
        this.base = process.env.VUE_APP_API_BASEURL;


        if(this.distribution_clients == null){
            this.loadDistributionClients();
        }
    },
}
</script>

<style>

</style>
